import {CreateView} from '@src/components/_views/configurable/CreateView';
import {withRouterApi} from '@src/HOCs/withRouterApi';
import {FormViewProps} from '@src/@types/components/FormViewProps';
import ContractorForm from '@views/contractors/ContractorForm';

export class ContractorCreateForm extends CreateView {
    protected getFormComponent() {
        return ContractorForm;
    }
}

export default ContractorCreateForm.getStoreConnector()(withRouterApi<FormViewProps>(ContractorCreateForm));
